module.exports = __webpack_public_path__ + "img/blitzpay.be195dd7.png";